const axios = require('axios');
const config = require('../../../../configuration/config');
const { ALLOCATIONS, DEFAULT_NUM_OF_GROUPS } = require('../../constants/experiments');

const ALLOCATIONS_URL = `${config.experiment_service.url}/allocations`;

const allocateToExperiment = async({
    userId,
    userGuid,
    experimentId,
    numOfGroups = DEFAULT_NUM_OF_GROUPS,
    abTests = {}
}) => {
    if (isAllocated(experimentId, abTests)) {
        return transformVariation(abTests[experimentId]);
    }

    try {
        const params = {
            user_id: userId,
            guest_id: userGuid,
            experiment_id: experimentId,
            num_of_groups: numOfGroups
        };

        const { data } = await axios.post(ALLOCATIONS_URL, params);

        return transformVariation(data[experimentId]);
    } catch (error) {
        error.description = `Unable to allocate user [${userId || userGuid}] to experiment [${experimentId}]`;
        throw error;
    }
};

const isAllocated = (experimentId, abTests = {}) => transformVariation(abTests[experimentId]) >= ALLOCATIONS.CONTROL;
const isInTestGroup = (experimentId, abTests = {}) => transformVariation(abTests[experimentId]) > ALLOCATIONS.CONTROL;

const transformVariation = (variation) => (
    Object.values(ALLOCATIONS).find((variationType) => !!variation && variationType === variation.toString()) || ALLOCATIONS.UNALLOCATED
);

module.exports = {
    allocateToExperiment,
    isAllocated,
    isInTestGroup,
    transformVariation
};
